import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostBinding, NgModule } from '@angular/core';
import * as i1 from 'se-fe-menu';
import { SeFeMenuModule } from 'se-fe-menu';
import * as i2 from 'se-fe-icon';
import { SeFeIconModule, seFeIconChevronRight, seFeIconChevronLeft } from 'se-fe-icon';

let count = 1;
class SeFePaginationComponent {
    constructor() {
        this.name = `SeFePagination-${count++}-${Date.now()}`;
        this.pageRanges = [];
        this.paginationMenu = { name: this.name, sections: [{ menuItems: [] }] };
        this.seFePaginationChange = new EventEmitter();
        this.baseClass = true;
        this.oldcurrentPage = 1;
    }
    ngDoCheck() {
        if (this.options.currentPage !== this.oldcurrentPage) {
            this.oldcurrentPage = this.options.currentPage;
            this.initializePagination();
        }
    }
    ngOnChanges(changes) {
        changes.options ? this.initializePagination() : null;
    }
    initializePagination() {
        this.label = this.options.label;
        this.currentPage = this.options.currentPage || 1;
        this.total = this.options.total || 0;
        this.updateLimits();
        this.setPageRange(this.limit);
    }
    previousPage() {
        if (this.disablePrevious)
            return;
        this.currentPage--;
        this.seFePaginationChange.emit({ currentPage: this.currentPage, limit: this.limit });
    }
    nextPage() {
        if (this.disableNext)
            return;
        this.currentPage++;
        this.seFePaginationChange.emit({ currentPage: this.currentPage, limit: this.limit });
    }
    get currentPageRange() {
        return this.pageRanges[this.currentPage - 1];
    }
    get disablePrevious() {
        return this.currentPage <= 1;
    }
    get disableNext() {
        return this.currentPage === Math.ceil(this.total / this.limit);
    }
    get displayNavigation() {
        return this.total / this.limit > 1;
    }
    // Ensure actual limit is part of the menu and that menue items are sorted correctly
    updateLimits() {
        this.limits = this.options.limits || [25, 50, 100];
        this.limit = this.options.limit || this.limit || this.limits[0];
        if (!this.limits.includes(this.limit)) {
            this.limits.push(this.limit);
            this.setPageRange(this.limit);
        }
        this.limits.sort((a, b) => a - b);
        const section = this.paginationMenu.sections[0];
        section.menuItems = this.limits.map(limit => {
            return { text: `${limit} per page`, action: () => this.updateLimit(limit) };
        });
    }
    updateLimit(limit) {
        if (limit !== this.limit)
            this.currentPage = 1;
        this.limit = limit;
        this.setPageRange(limit);
        this.seFePaginationChange.emit({ currentPage: this.currentPage, limit: this.limit });
    }
    setPageRange(limit) {
        this.pageRanges = Array.from({ length: Math.ceil(this.total / limit) }, (_, i) => this.getPageLabel(this.total, limit, i));
    }
    getPageStart(limit, pageNumber) {
        return limit * pageNumber;
    }
    getPageLabel(total, limit, pageNumber) {
        const start = Math.max(this.getPageStart(limit, pageNumber), 0);
        const end = Math.min(this.getPageStart(limit, pageNumber + 1), total);
        return `${start + 1}–${end}`;
    }
}
SeFePaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFePaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFePaginationComponent, selector: "se-fe-pagination", inputs: { options: ["seFeDataPaginationOptions", "options"] }, outputs: { seFePaginationChange: "seFePaginationChange" }, host: { properties: { "class.se-fe-pagination": "this.baseClass" } }, usesOnChanges: true, ngImport: i0, template: "<nav class=\"se-fe-pagination\" aria-label=\"pagination\">\n  <button\n    [seFeMenuTrigger]=\"paginationMenu.name\"\n    [attr.aria-label]=\" limit + ' items per page'\"\n    class=\"se-fe-pagination__menu\">\n    {{ currentPageRange }}\n  </button>\n  <se-fe-menu [seFeDataOptions]=\"paginationMenu\"></se-fe-menu>\n  <span aria-hidden=\"true\"> of {{total}} {{label}}</span>\n  <span class=\"se-fe-sr-only\">page {{currentPage}} of {{pageRanges.length}}</span>\n  <span class=\"se-fe-pagination__buttons\" *ngIf='displayNavigation'>\n    <button\n      aria-label=\"prevous page\"\n      [attr.aria-disabled]='disablePrevious'\n      (click)=\"previousPage()\">\n      <se-fe-icon\n        seFeDataName=\"chevron_left\"\n        seFeDataSize=\"700\">\n      </se-fe-icon>\n    </button>\n    <button\n      aria-label=\"next page\"\n      [attr.aria-disabled]='disableNext'\n      (click)=\"nextPage()\">\n      <se-fe-icon\n        seFeDataName=\"chevron_right\"\n        seFeDataSize=\"700\">\n      </se-fe-icon>\n    </button>\n  </span>\n</nav>\n", styles: [":host{font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif}.se-fe-pagination{margin-top:8px;text-align:right}.se-fe-pagination__menu{font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif;background:0 0;border:0;color:#00668f;cursor:pointer;outline:0;padding:0;text-decoration:underline}.se-fe-pagination__menu:focus{outline:thin dotted}.se-fe-pagination__buttons{display:inline-flex;vertical-align:middle;margin-left:5px}.se-fe-pagination__buttons>button{display:flex;align-items:center;justify-content:center;border:none;width:48px;height:48px;border-radius:50%;padding:3px;background:transparent;color:#68767f}.se-fe-pagination__buttons>button:hover,.se-fe-pagination__buttons>button:focus{outline:none;z-index:10}.se-fe-pagination__buttons>button:hover{background:rgba(104,118,127,.04)}.se-fe-pagination__buttons>button:focus{background:rgba(104,118,127,.12)}.se-fe-pagination__buttons>button:active{background:rgba(104,118,127,.16)}.se-fe-pagination__buttons>button[aria-disabled=true]{background:transparent;color:#c1cace}.se-fe-pagination__buttons>button[aria-disabled=false]{cursor:pointer}.se-fe-pagination__buttons>button:not(:first-child){margin-left:-1px}.se-fe-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}\n"], components: [{ type: i1.SeFeMenuComponent, selector: "se-fe-menu", inputs: ["visible", "seFeDataOptions", "seFeDataMaxHeight", "seFeDataMinWidth", "seFeDataCardLabel"] }, { type: i2.SeFeIconComponent, selector: "se-fe-icon", inputs: ["seFeDataAriaLabel", "seFeDataSize", "seFeDataColor", "seFeDataName", "seFeDataMargin"] }], directives: [{ type: i1.SeFeMenuTriggerDirective, selector: "[seFeMenuTrigger]", inputs: ["seFeMenuTrigger"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePaginationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-pagination',
                    templateUrl: './se-fe-pagination.component.html',
                    styleUrls: ['./se-fe-pagination.component.scss'],
                }]
        }], propDecorators: { options: [{
                type: Input,
                args: ['seFeDataPaginationOptions']
            }], seFePaginationChange: [{
                type: Output
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-pagination']
            }] } });

class SeFePaginationModule {
}
SeFePaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFePaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePaginationModule, declarations: [SeFePaginationComponent], imports: [CommonModule,
        SeFeMenuModule, i2.SeFeIconModule], exports: [SeFePaginationComponent] });
SeFePaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePaginationModule, imports: [[
            CommonModule,
            SeFeMenuModule,
            SeFeIconModule.include([
                seFeIconChevronRight,
                seFeIconChevronLeft,
            ])
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFePaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFePaginationComponent],
                    imports: [
                        CommonModule,
                        SeFeMenuModule,
                        SeFeIconModule.include([
                            seFeIconChevronRight,
                            seFeIconChevronLeft,
                        ])
                    ],
                    exports: [SeFePaginationComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFePaginationComponent, SeFePaginationModule };
